'use strict';

angular.module('mean.users')
  .controller('AuthCtrl', ['$scope', '$rootScope', '$http', '$state', 'Global',
    function($scope, $rootScope, $http, $state, Global) {
      $scope.socialButtonsCounter = 0;
      $scope.global = Global;
      $scope.$state = $state;

      $http.get('/api/get-config')
        .success(function(config) {
          if(config.hasOwnProperty('local')) delete config.local;

          $scope.socialButtons = config;
          $scope.socialButtonsCounter = Object.keys(config).length;
        });
    }
  ])
  .controller('VerifyCtrl', ['$rootScope', 'MeanUser',
    function($rootScope, MeanUser) {
      var vm = this;
      vm.user = {};
      vm.input = {
        type: 'password',
        placeholder: 'Password',
        confirmPlaceholder: 'Repeat Password',
        iconClass: '',
        tooltipText: 'Show password'
      };
      vm.togglePasswordVisible = function() {
        vm.input.type = vm.input.type === 'text' ? 'password' : 'text';
        vm.input.placeholder = vm.input.placeholder === 'Password' ? 'Visible Password' : 'Password';
        vm.input.iconClass = vm.input.iconClass === 'icon_hide_password' ? '' : 'icon_hide_password';
        vm.input.tooltipText = vm.input.tooltipText === 'Show password' ? 'Hide password' : 'Show password';
      };
      // $rootScope.$on('verifyfailed', function(){
      //   vm.verifyError = MeanUser.verifyError;
      // });

      // $rootScope.$on('userVerified', function(event, data){
      //   console.log('verified user identity');
      //   console.log(data);
      // });

      //this one is used for the clock crew functionality
      vm.verifyUser = function() {
        console.log('in the verify function')
        MeanUser.verifyuser(this.returnedOptions);
      };

      vm.verify = function() {
        console.log('in the verify function')
        MeanUser.verifyguest(this.returnedOptions);
      };
    }
  ])
  .controller('LoginCtrl', ['$rootScope', 'MeanUser',
    function($rootScope, MeanUser) {
      var vm = this;
      vm.user = {};
      vm.input = {
        type: 'password',
        placeholder: 'Password',
        confirmPlaceholder: 'Repeat Password',
        iconClass: '',
        tooltipText: 'Show password'
      };
      vm.togglePasswordVisible = function() {
        vm.input.type = vm.input.type === 'text' ? 'password' : 'text';
        vm.input.placeholder = vm.input.placeholder === 'Password' ? 'Visible Password' : 'Password';
        vm.input.iconClass = vm.input.iconClass === 'icon_hide_password' ? '' : 'icon_hide_password';
        vm.input.tooltipText = vm.input.tooltipText === 'Show password' ? 'Hide password' : 'Show password';
      };
      $rootScope.$on('loginfailed', function(){
        vm.loginError = MeanUser.loginError;
      });

      vm.login = function() {
        MeanUser.login(this.user);
      };
    }
  ])
  .controller('RegisterCtrl', ['$rootScope', 'MeanUser',
    function($rootScope, MeanUser) {
      var vm = this;
      vm.user = {};
      vm.registerForm = MeanUser.registerForm = true;
      vm.input = {
        type: 'password',
        placeholder: 'Password',
        placeholderConfirmPass: 'Repeat Password',
        iconClassConfirmPass: '',
        tooltipText: 'Show password',
        tooltipTextConfirmPass: 'Show password'
      };
      vm.togglePasswordVisible = function() {
        vm.input.type = vm.input.type === 'text' ? 'password' : 'text';
        vm.input.placeholder = vm.input.placeholder === 'Password' ? 'Visible Password' : 'Password';
        vm.input.iconClass = vm.input.iconClass === 'icon_hide_password' ? '' : 'icon_hide_password';
        vm.input.tooltipText = vm.input.tooltipText === 'Show password' ? 'Hide password' : 'Show password';
      };
      vm.togglePasswordConfirmVisible = function() {
        vm.input.type = vm.input.type === 'text' ? 'password' : 'text';
        vm.input.placeholderConfirmPass = vm.input.placeholderConfirmPass === 'Repeat Password' ? 'Visible Password' : 'Repeat Password';
        vm.input.iconClassConfirmPass = vm.input.iconClassConfirmPass === 'icon_hide_password' ? '' : 'icon_hide_password';
        vm.input.tooltipTextConfirmPass = vm.input.tooltipTextConfirmPass === 'Show password' ? 'Hide password' : 'Show password';
      };

      vm.register = function() {
        MeanUser.register(this.user);
      };

      $rootScope.$on('registerfailed', function(){
        vm.registerError = MeanUser.registerError;
      });
    }
  ])
  .controller('ForgotPasswordCtrl', ['MeanUser', '$rootScope',
    function(MeanUser, $rootScope) {
      var vm = this;
      vm.user = {};
      vm.registerForm = MeanUser.registerForm = false;

      vm.forgotpassword = function() {
        console.log('forgotpassword function');
        MeanUser.forgotpassword(this.user);
      };

      $rootScope.$on('forgotmailsent', function(event, args){
        vm.response = args;
      });
    }
  ])
  .controller('ResetPasswordCtrl', ['MeanUser', '$rootScope', '$location', 'ngDialog',
    function(MeanUser, $rootScope, $location, ngDialog) {
      console.log('in the ResetPasswordCtrl controller');

      var vm = this;
      vm.user = {};
      vm.need_password_reset = MeanUser.user.need_password_reset;
      vm.loggedin = MeanUser.loggedin;
      vm.registerForm = MeanUser.registerForm = false;

      $rootScope.$on('loggedin', function(event){
        console.log('in the loggedin event');
        if(MeanUser.resetpassworderror)
          vm.resetpassworderror = MeanUser.resetpassworderror;
        else {
          vm.resetpasswordsuccess = 'Password Changed Successfully';
          vm.user.password =
          vm.user.confirmPassword = '';
          $location.url('/');
        }
      });

      $rootScope.$on('loginfailed', function(event, args){
        console.log('in the loginfailed event', event, args);
        if(args.resetpassworderror) {
          vm.resetpassworderror = args.resetpassworderror;
          if(angular.isArray(args.registerError))
            vm.validationError = args.registerError;
          else {
            vm.validationError = [];
            vm.validationError.push(args.registerError);
          }
        } else {
          vm.resetpassworderror = 'Password Reset Failed';
          if(angular.isArray(args.registerError))
            vm.validationError = args.registerError;
          else {
            vm.validationError = [];
            vm.validationError.push(args.registerError);
          }
        }
      });

      $rootScope.$on('reset_password', function(event, args){
        console.log('got the reset_password event');
        console.log(event);
        console.log(args);
      });

      vm.resetpassword = function() {
        console.log('in the resetpassword function');
        if(!vm.tos_agreement && vm.need_password_reset) {
          vm.resetpassworderror = 'You must agree to the Terms of Service';
          return;
        }
        MeanUser.resetpassword(this.user);
      };

      vm.resetAuthorized = function() {
        vm.resetpasswordsuccess =
        vm.resetpassworderror =
        vm.validationError = '';
        console.log('in the resetAuthorized function');
        if(!vm.tos_agreement && vm.need_password_reset) {
          vm.resetpassworderror = 'You must agree to the Terms of Service';
          return;
        }
        this.user.need_password_reset = this.need_password_reset;
        this.user.tos_agreement = this.tos_agreement;
        MeanUser.resetAuthorized(this.user);
      }

      vm.needsReset = function() {
        return vm.need_password_reset;
      }

      vm.readTOS = function() {
        console.log('in the readTOS function');
        ngDialog.open({
            template: 'admin/views/ACE-Software-SAAS-TOS.html',
            className: 'ngdialog-theme-default custom-width-800'
        });
      }
    }
  ]);



// WEBPACK FOOTER //
// ./packages/custom/users/public/controllers/meanUser.js